/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsupcomingcaption2Inputs */

const en_statsupcomingcaption2 = /** @type {(inputs: Statsupcomingcaption2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming plans`)
};

const de_statsupcomingcaption2 = /** @type {(inputs: Statsupcomingcaption2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anstehende Pläne`)
};

/**
* | output |
* | --- |
* | "Upcoming plans" |
*
* @param {Statsupcomingcaption2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsupcomingcaption2 = /** @type {((inputs?: Statsupcomingcaption2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsupcomingcaption2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsupcomingcaption2(inputs)
	return de_statsupcomingcaption2(inputs)
});
export { statsupcomingcaption2 as "statsUpcomingCaption" }